// extracted by mini-css-extract-plugin
export default {"coachItem":"CoachItem_coachItem__FKJLC","info":"CoachItem_info__WFA6T"};